/**
 * A module record as a viewer may act on it: neither editable nor reviewable.
 *
 * @module components/studio/view-only-record
 */

import { useMemo } from "react";

import type { ModuleWorkspaceRecord } from "@/platform";

export function useViewOnlyRecord(
  record: ModuleWorkspaceRecord | null,
  viewOnly: boolean,
): ModuleWorkspaceRecord | null {
  return useMemo(
    () => (viewOnly && record ? { ...record, canEdit: false, canReview: false } : record),
    [record, viewOnly],
  );
}
